import React from 'react';
import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import CustomTextField from '../common/custom-components/customTextField';
import InfoMessageBar from '../common/info-message/info-message';
import PropTypes from 'prop-types';
import Link1 from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import {
  required,
  firstName,
  lastName,
  companyName,
  street,
  streetline2,
  city,
  zipCode,
  password,
  email,
  maxLength5,
  phoneNumber,
  number,
  passwordsMustMatch,
  state,
  // isURL,
  PASSWORD_POLICY,
} from '../../constants/constants';
import { stateCodes } from '../../constants/states-constants';
import { CustomSelectField } from '../common/custom-components/customDropDown';

export const RegistrationForm = ({
  errors,
  handleSubmit,
  handleBack,
  handleExistingUsers,
  invalid,
  submitting,
  pristine,
}) => {
  return (
    <div className="container page" style={{ backgroundColor: '#F7F8F9' }}>
      <div className="row">
        <div className="col-md-6 offset-md-3 col-xs-12">
          <Card boxShadow={3}>
            <h1 className="text-xs-center">Sign Up</h1>
            <p className="text-xs-center">
              <Link to="/login">Have an account?</Link>
            </p>
            {errors && (
              <React.Fragment>
                <InfoMessageBar
                  icColor="errorIc"
                  variant="error"
                  message={errors}
                />
                <div className="row link-margin">
                  <Link1
                    component="button"
                    variant="body2"
                    onClick={handleExistingUsers}
                  >
                    Click here to confirm your Registration
                  </Link1>
                </div>
              </React.Fragment>
            )}
            <Typography variant="h6" style={{ color: 'red', margin: 20 }}>
              Attention: This Portal is ONLY for Insurance Agents
            </Typography>
            <form
              autoComplete="new-password"
              noValidate
              onSubmit={handleSubmit}
            >
              <CardContent>
                <Field
                  className="TextField-border-radius "
                  color="primary"
                  component={CustomTextField}
                  name="firstName"
                  symbol="FirstName"
                  placeholder="Enter firstName"
                  required
                  type="text"
                  validate={[required, firstName]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="lastName"
                  symbol="LastName"
                  placeholder="Enter lastName"
                  required
                  type="text"
                  validate={[required, lastName]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />
                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="phonenumber"
                  symbol="PhoneNo #"
                  placeholder="Enter phone Number #"
                  required
                  type="text"
                  validate={[required, phoneNumber]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="companyName"
                  symbol="CompanyName"
                  placeholder="Enter company name"
                  required
                  type="text"
                  validate={[required, companyName]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className=" TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="Str"
                  symbol="Address Line 1"
                  placeholder="Enter address line 1"
                  required
                  type="text"
                  validate={[required, street]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="str2"
                  symbol="Address Line 2"
                  placeholder="Enter address line 2"
                  type="text"
                  validate={[streetline2]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="city"
                  symbol="City"
                  placeholder="Enter city"
                  required
                  type="text"
                  validate={[required, city]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  component={CustomSelectField}
                  label=""
                  name="state"
                  type="select"
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                  required
                  validate={[required, state]}
                >
                  {stateCodes.map(item => (
                    <option key={item.abbreviation} value={item.abbreviation}>
                      {item.name}
                    </option>
                  ))}
                </Field>

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="zip"
                  symbol="ZipCode"
                  placeholder="ZipCode"
                  required
                  type="text"
                  validate={[required, number, maxLength5, zipCode]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="url"
                  symbol="Company Website"
                  placeholder="Enter company website"
                  type="text"
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="email"
                  symbol="Email"
                  placeholder="Enter email address"
                  required
                  type="email"
                  validate={[required, email]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="newPassword"
                  symbol="password"
                  placeholder="Enter password"
                  required
                  type="password"
                  validate={[required, password]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />
                <Box
                  component="div"
                  m={1}
                  color="text.primary"
                  style={{ border: '1px solid black', padding: 28 }}
                >
                  <Typography
                    variant="body1"
                    component="p"
                    className="text-xs-center"
                  >
                    {PASSWORD_POLICY}
                  </Typography>
                </Box>

                <Field
                  className="TextField-border-radius"
                  color="primary"
                  component={CustomTextField}
                  name="password"
                  symbol="password"
                  placeholder="Enter password"
                  required
                  type="password"
                  validate={[required, password, passwordsMustMatch]}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                />

                <div className="botton-group">
                  <Button
                    className="btn-lg "
                    disabled={invalid || submitting || pristine}
                    type="submit"
                    variant="contained"
                    style={{
                      padding: '15px 50px',
                      borderRadius: 28,
                      marginRight: 40,
                    }}
                    color="primary"
                    fullWidth
                  >
                    REGISTER
                  </Button>
                  <div className="link-pad">
                    <Link1
                      className="btn btn-lg "
                      component="button"
                      variant="body2"
                      alignText="center"
                      onClick={handleBack}
                      style={{
                        fontSize: 20,
                        fontFamily: 'Arial',
                      }}
                    >
                      CANCEL
                    </Link1>
                  </div>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </div>
    </div>
  );
};

RegistrationForm.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  handleExistingUsers: PropTypes.func,
  invalid: PropTypes.func,
  submitting: PropTypes.func,
  pristine: PropTypes.func,
};

export default reduxForm({
  form: 'registerForm',
  // a unique identifier for this form
})(RegistrationForm);
